import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { BusinessGroupLinkService } from 'src/app/Service/businessgroup-link/business-group-link.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';
import { groupBy } from 'lodash';
import { NotificationService } from 'src/app/Service/notification.service';
import { CommonService } from 'src/app/Service/Common.service';
import * as moment from 'moment';

const createFormGroup = (dataItem: { group_Id: any; group_Name: any; group_Short_Name: any; is_Active: any; group_Code: any; group_Logo_URL: any; group_Head_Id: any; user_Id: any; }) => new FormGroup({
  'group_Id': new FormControl(dataItem.group_Id),
  'group_Name': new FormControl(dataItem.group_Name),
  'group_Short_Name': new FormControl(dataItem.group_Short_Name),
  'is_Active': new FormControl(dataItem.is_Active),
  'group_Code': new FormControl(dataItem.group_Code),
  'group_Logo_URL': new FormControl(dataItem.group_Logo_URL),
  'group_Head_Id': new FormControl(dataItem.group_Head_Id),
  'user_Id': new FormControl(dataItem.user_Id),
});

@Component({
  selector: 'app-business-group-link',
  templateUrl: './business-group-link.component.html',
  styleUrls: ['./business-group-link.component.css']
})
export class BusinessGroupLinkComponent implements OnInit {

  @ViewChild(GridComponent)
  private grid!: GridComponent;

  /** Dropdown data */
  organizationList !: any| IOrganizationViewModel[];
  /** Dropdown Filtered data */
  organizationListFiltered!: any| IOrganizationViewModel[];
  /** Kendo data */
  organizationListAgainstProject: IOrganizationViewModel[] | undefined;

  /** Grouped by GroupName */
  groupdByGrpName: any;

  public formGroup: FormGroup | undefined;
  enableFilter = false;
  enableFullscreen = false;
  isNew = false;
  public pageSize = [5, 10, 20, {
    text: 'All',
    value: 'all'
  }];

  editedRowIndex !: number;
  /** Selected row group id */
  editedRowGroupId:any = null;

  isNewRow = false;


  constructor(
    private businessGroupLinkService: BusinessGroupLinkService,
    private organisationSerice: OrganizationService,
    public notificationService: NotificationService,
    public commonService: CommonService,
  ) { }

  ngOnInit() {

    this.callApis();
    // this.getOrganizationList();
    // this.getMappedOrganizationAgainstProject();
  }


  async callApis() {
    this.organizationList = await this.organisationSerice.getOrganizationList(undefined||null).toPromise();
    /** Both active and inactive */
    this.organizationListAgainstProject = await this.businessGroupLinkService.getMappedOrganizationAgainstProject().toPromise();
    // assign only active object
    //this.organizationListAgainstProject = organisationAllList.filter(eachOrg => eachOrg.is_Active);    
    this.filterWithDropdownList();
  }


  filterWithDropdownList() {
    this.groupdByGrpName = groupBy(this.organizationListAgainstProject, 'group_Name');

    this.organizationListFiltered = [];
    this.organizationList.forEach((eachGrp: IOrganizationViewModel) => {
      if (!(this.groupdByGrpName[eachGrp.group_Name] && this.groupdByGrpName[eachGrp.group_Name].length)) {
        this.organizationListFiltered.push(eachGrp);
      }
    });
  }


  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  addGroup() {
    // let newOrganisat
  }

  changeActiveStatus(event: { checked: any; }) {
    this.formGroup?.get('is_Active')?.setValue(event.checked);
  }

  changeGroupName(event: EIPAutoCompleteEventModel<IOrganizationViewModel>) {
    if (event.value != '-2') {
      this.formGroup?.get('group_Id')?.setValue(event.value);
      this.formGroup?.get('group_Name')?.setValue(event.text);
    } else {
      this.formGroup?.get('group_Id')?.setValue(null);
      this.formGroup?.get('group_Name')?.setValue('');
    }
  }

  editRowData(data:any) {
    //closing previous row, if anything opened
    if (this.editedRowIndex >= 0) {
      data.sender.closeRow(this.editedRowIndex);
    }

    this.editedRowIndex = data.rowIndex;
    this.formGroup = createFormGroup(data.dataItem);
    this.isNewRow = false;
    data.sender.editRow(data.rowIndex);
  }

  UpdateRowData(data:any) {
    // Group name  validation 
    if (!data.dataItem.group_Name) {
      this.notificationService.showToast("Select Group name", "Warning");
      return;
    }

    this.saveBusinessGroupLink();
    this.isNewRow = false;
    data.sender.closeRow(data.rowIndex);
  }

  cancelRowData(data:any) {
    this.isNewRow = false;
    data.sender.closeRow(data.rowIndex);
  }


  addHandler() {
    this.isNewRow = true;
    this.closeEditor();
    this.formGroup = createFormGroup({
      group_Id: null,
      group_Name: '',
      group_Short_Name: '',
      is_Active: true,
      group_Code: '',
      group_Logo_URL: '',
      group_Head_Id: null,
      user_Id: this.commonService.getLoggedInUserId(),
    });
    this.isNew = true;
    this.grid.addRow(this.formGroup);
  }

  public cellClickHandler(data:any): void {

    if (data.isEdited) {
      return;
    }
    this.saveBusinessGroupLink();
    this.formGroup = createFormGroup(data.dataItem);
    this.editedRowIndex = data.rowIndex;
    this.grid.editRow(data.rowIndex, this.formGroup);
  }


  public cancelHandler(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);

    this.isNew = false;
    this.editedRowIndex = 0;
    this.formGroup = undefined;
  }


  saveBusinessGroupLink() {

    if (this.formGroup) {
      let newBusinessGroup: any | IOrganizationViewModel = {
        group_Id: this.formGroup.get('group_Id')?.value,
        group_Name: this.formGroup.get('group_Name')?.value,
        group_Short_Name: this.formGroup.get('group_Short_Name')?.value,
        is_Active: this.formGroup.get('is_Active')?.value,
        group_Code: this.formGroup.get('group_Code')?.value,
        group_Logo_URL: this.formGroup.get('group_Logo_URL')?.value,
        group_Head_Id: this.formGroup.get('group_Head_Id')?.value,
        user_Id: this.formGroup.get('user_Id')?.value,
      }

      this.businessGroupLinkService.saveOrganization(newBusinessGroup.group_Id, newBusinessGroup.group_Head_Id, newBusinessGroup.is_Active).subscribe(data => {
        this.notificationService.handleResponse(data);
        this.callApis();
        // this.getMappedOrganizationAgainstProject();
      });
    }
    this.closeEditor();

    // if(THIS)
  }
 

}
